import React from 'react'
import { Link } from 'react-router-dom'
import moment from 'moment'

const badgeClass = (days) => {
  if (days <= 14) return 'dbv2-badge-red'
  if (days <= 60) return 'dbv2-badge-yellow'
  return 'dbv2-badge-green'
}

/**
 * US-DB-4 — certificates expiring within today + 90 days, soonest first,
 * paginated (AC-8/AC-9). Real-time; no filter.
 */
export default function ExpiringCertificates ({ data, loading, onPageChange }) {
  if (loading && !data) {
    return (
      <div className='dbv2-card'>
        <p className='dbv2-card-title'>Sertifikat Akan Expire</p>
        <div className='dbv2-loading'>Memuat…</div>
      </div>
    )
  }
  if (!data) return null

  const items = data.items || []
  const page = data.page || 1
  const totalPages = data.totalPages || 1

  // Compact page list: first, current±1, last.
  const pages = []
  for (let p = 1; p <= totalPages; p++) {
    if (p === 1 || p === totalPages || Math.abs(p - page) <= 1) {
      if (pages.length && p - pages[pages.length - 1] > 1) pages.push(null)
      pages.push(p)
    }
  }

  return (
    <div className='dbv2-card'>
      <p className='dbv2-card-title'>Sertifikat Akan Expire</p>
      <p className='dbv2-card-subtitle'>Prioritas renewal — 90 hari ke depan</p>
      { items.length === 0
        ? <div className='dbv2-empty'>Tidak ada sertifikat yang akan expire dalam 90 hari.</div>
        : <table className='dbv2-expire-table'>
          <thead>
            <tr><th>Customer</th><th>Order No.</th><th>Standard</th><th>Expire</th></tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.certificateId}>
                <td>{item.customer || '—'}</td>
                <td className='dbv2-expire-order'>
                  { item.orderId && item.orderNumber
                    ? <Link to={`/orders/${item.orderId}`}>{item.orderNumber}</Link>
                    : (item.orderNumber || '—')
                  }
                </td>
                <td>{item.standard || '—'}</td>
                <td>
                  <span
                    className={`dbv2-badge ${badgeClass(item.daysLeft)}`}
                    title={moment(item.expireDate).format('DD/MM/YYYY')}
                  >
                    {item.daysLeft} hari
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      }
      { totalPages > 1 &&
        <div className='dbv2-pagination'>
          <button disabled={page <= 1} onClick={() => onPageChange(page - 1)}>‹</button>
          {pages.map((p, i) => (
            p === null
              ? <button key={`gap-${i}`} disabled>…</button>
              : <button
                key={p}
                className={p === page ? 'dbv2-active' : ''}
                onClick={() => onPageChange(p)}
              >{p}</button>
          ))}
          <button disabled={page >= totalPages} onClick={() => onPageChange(page + 1)}>›</button>
        </div>
      }
    </div>
  )
}
